module.exports = __webpack_public_path__ + "static/img/ecological_institute_cooperation_tylg.7f25362.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ecological/ecological_institute_cooperation_tylg.png
// module id = qkpp
// module chunks = 0